import React, { useState, useEffect } from "react";
import { useStatePtr, useData } from "@pure-ptr/react";

import {
    Box,
    IconButton,
    Tooltip,
    Typography,
    Grid
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { CustomLabel, Loadable, PopoverLink } from "../../../../common";
import { Edit as EditIcon } from "@mui/icons-material";
import { AssignedRCMTeamsHistory } from "./AssignedRCMTeamHistory";
import {
    getRCMAssignmentHistory,
    updateRCMTeam,
} from "../../../../store/api/rcmAssignment";
import CloseIcon from "@mui/icons-material/Close";
import { rcmAssignmentLanding } from "../../../../store/actions/rcmAssignment";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/reducers";
import { selectHasRcmTeamAccess } from "../../../../store/selectors/session";
import { errorToastify } from "../../../../util/toast";
import RCMTeamsDropdown from "../RCMTeamsDropdown/RCMTeamsDropdown";
import { getAllRCMTeamsList } from "../../../../store/api/rcmAssignment";

const useStyles = makeStyles((theme) => ({
    autoComplete: {
        width: "100%",
        "& .MuiFormControl-marginNormal": {
            marginTop: 0,
        },
    },
    box: {
        display: "inline-block",
    },
    underline: {
        textDecoration: "underline",
        color: "#2739c1",
        cursor: "pointer",
    },
    rightBox: {
        display: "inline-block",
        float: "right",
    },
}));

const AssignRCMTeamSection = ({ claimAllDetails, assignClaimsCallback }) => {
    const classes = useStyles();
    const dialogAssignedClaims = useStatePtr(false);
    const [requiredHistory, setRequiredHistory] = useState(0);
    const [isEdit, setEdit] = useState(false);
    const [updateRcmTeamPayload, setUpdateRcmTeamPayload] = useState<any>(null);

    const dispatch = useDispatch();

    let canAccessRcm=useSelector(selectHasRcmTeamAccess)

    let currentRcmTeamName = claimAllDetails?.rcmTeam?.name || "";

    const handleClose = () => {
        setEdit(false);
    };

    const {
            data:rcmAssignmentData,
        } = useData(async () => {
            if(!canAccessRcm) return;
            const allRcmTeams = await getAllRCMTeamsList();
            return allRcmTeams;
        }, [canAccessRcm]);

    const handleChangeMode = (bool) => {
        setEdit(bool);
    };
    const {
        data: rcmAssignmentHistory,
        isPending,
        error,
        reload,
    } = useData(async () => {
        if (!Boolean(requiredHistory)) return;
        if(!dialogAssignedClaims.value) return;
        const assignedClaimData = await getRCMAssignmentHistory(
            claimAllDetails?.id
        );
        return assignedClaimData;
    }, [requiredHistory, claimAllDetails?.id]);

    const {
        data,
        isPending: isUpdatingRcmTeam,
        error: errorUpdatingRcmTeam,
    } = useData(async () => {
        if (!updateRcmTeamPayload || Object.keys(updateRcmTeamPayload)?.length <= 0) return;
        const assignedClaimData = await updateRCMTeam(
            claimAllDetails?.id,
            updateRcmTeamPayload?.id
        );
        setUpdateRcmTeamPayload(null);
        setEdit(false);
        assignClaimsCallback();
        reload()
        return assignedClaimData;
    }, [updateRcmTeamPayload]);


    const handleConfirmChangeStatus = (value) => {
        setUpdateRcmTeamPayload({ ...value });
    };

        useEffect(() => {
            if (!errorUpdatingRcmTeam) return;
            errorToastify(
                errorUpdatingRcmTeam?.payload?.error ||
                    "Something Went Wrong !! Please Contact Administrator"
            );
        }, [errorUpdatingRcmTeam]);
    
    return (
        <Loadable loading={isUpdatingRcmTeam!==null}>
            {isEdit ? (
                <Grid container alignItems="center">
                    <Grid item xs={7}>
                        <RCMTeamsDropdown
                            classes={classes}
                            tempRcmTeam={updateRcmTeamPayload}
                            currentRcmTeamName={currentRcmTeamName}
                            handleStatusChange={handleConfirmChangeStatus}
                            rcmAssignmentData={rcmAssignmentData}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Tooltip title="Cancel">
                            <IconButton
                                className="ml-2"
                                aria-label="process"
                                size="small"
                                onClick={handleClose}
                            >
                                <CloseIcon style={{ fontSize: "20px" }} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            ) : (
                <>
                    <CustomLabel
                        label="RCM Team"
                        data={
                            <PopoverLink
                                columnData={currentRcmTeamName || "Unassigned"}
                                title={"Unassigned"}
                                customClasses="aligned-content"
                            />
                        }
                        type="claim-contract"
                    />

                    {(canAccessRcm) && (
                        <Box className={classes.box}>
                            <Tooltip title="Change RCM Team">
                                <IconButton
                                    className="ml-2 p-1"
                                    aria-label="Edit"
                                    onClick={() => handleChangeMode(true)}
                                    size="large"
                                >
                                    <EditIcon style={{ fontSize: "22px" }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                </>
            )}

            <Box className={classes.rightBox}>
                <Typography
                    onClick={() => {
                        setRequiredHistory(requiredHistory + 1);
                        dialogAssignedClaims.set(true);
                    }}
                    color="primary"
                    className={`${classes.underline}`}
                >
                    History
                </Typography>
            </Box>
            <AssignedRCMTeamsHistory
                openPtr={dialogAssignedClaims}
                handleClose={() => dialogAssignedClaims.set(false)}
                isPending={isPending}
                assignedClaimData={rcmAssignmentHistory}
                reload={reload}
            />

        </Loadable>
    );
};

export default AssignRCMTeamSection;
